import { render, staticRenderFns } from "./giftModal.vue?vue&type=template&id=0f6c72f2&scoped=true"
import script from "./giftModal.vue?vue&type=script&lang=ts"
export * from "./giftModal.vue?vue&type=script&lang=ts"
import style0 from "./giftModal.vue?vue&type=style&index=0&id=0f6c72f2&prod&lang=css"
import style1 from "./giftModal.vue?vue&type=style&index=1&id=0f6c72f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6c72f2",
  null
  
)

export default component.exports